import React from "react";
import "./Solar_Power.css";

import { SolarPowers } from "../../../utils/apis/homepage/index";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const Solar_Power = () => {
  const solarData = [
    {
      title: "Smart Solar Solutions",
      span: "  for Homes",
      text:
        "Reduce electricity bills and enjoy reliable, clean energy with easy-to-install residential solar systems.",
      img: "/assets/images/home/solar_power/img-1.png",
    },
    {
      title: "Solar Power for",
      span: "   Housing Societies",
      text:
        "Power common areas efficiently while cutting maintenance costs with scalable solar solutions for societies.",
      img: "/assets/images/home/solar_power/img-2.png",
    },
    {
      title: "Solar Solutions for",
      span: " Commercial & Industrial",
      text:
        "High-performance solar systems designed to lower operational costs and support sustainable business growth.",
      img: "/assets/images/home/solar_power/img-3.png",
    },
  ];


  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();


  const { IMG_URL } = useContext(Context);
  
    const [solarpower, setSolarPower] = useState([]);
  
    const getSolarPowers = async () => {
      const res = await SolarPowers();
      if (res?.success) {
        setSolarPower(res.data);
      }
    };
    useEffect(() => {
      getSolarPowers();
    }, []);


  return (
    <section className="Solar_Power">
      <div className="container">
        <div className="section_header_holder">
          <h5 className="section_title">Solar Power for Every Space</h5>
          <p className="section_subtitle">
            Customized, cost-effective solar systems designed to meet
            residential and business energy needs.
          </p>
        </div>

        <div className="solar_card_div">
          <div className="row justify-content-center">
            {solarpower.map((item, index) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-5 mt-3"
                key={index}
              >
                <div className="solar_box">
                  <div className="solar_content">
                    <h5 className="card_title">{item.name}</h5>
                    <p className="card_span">{item.subtitle}</p>
                    <p className="card_text">{htmlToReactParser.parse(item.description)}</p>
                  </div>
                  <div className="solar_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item.title}
                      className="solar_img"
                    />
                  </div>

                  {/* <div className="card_btn_holder">
                    <button className="card_btn">Explore Now</button>{" "}
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solar_Power;
